<div class="container">
  <div class="row">
    <div style="width: 100%;">
      <app-license-detail
        *ngIf="licenseData && licenseId"
        [licenseId]="licenseId"
        [licenseNumber]="licenseData.licenseNumber"
        [restrictions]="licenseData.asset.drivingRestriction"
        [realMunicipalLicenses]="licenseData.municipalLicenses"
        [shouldShowPersonalData]="false"
        [shouldShowFlow]="false"
        [shouldShowRequestNumberTitle]="true"
        [shouldShowDocumentLinks]="true"
        backButtonText="Seleccionar otra licencia"
        [shouldShowLicenseSection]="true"

        [gettingDataRequirement]="licenseDataGetting"
        [getDetailsError]="licenseDataError"
        [equipments]="equipments"
        [documents]="documents"
        [assetId]="licenseData.asset.id"

        [personRutDv]="personRutDv"
        [requirementId]="licenseData.requirementId"
        (goBack)="onGoBack()"
      >
      </app-license-detail>
    </div>
  </div>
</div>
